import React, { useState } from 'react';
import { company, contact } from '../../models/content';
import V2AddressText from '../components/V2AddressText';

const emptyValues = { name: '', email: '', phone: '', message: '' };

function validateContactForm(values) {
  const errors = {};
  const name = values.name.trim();

  if (!name) {
    errors.name = 'Name is required.';
  } else if (name.length < 4) {
    errors.name = 'Name must be at least 4 characters long.';
  } else if (/^\d+$/.test(name)) {
    errors.name = 'Name cannot be completely numeric.';
  }

  const email = values.email.trim();
  if (!email) {
    errors.email = 'Email is required.';
  } else if (!email.includes('@') || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = 'Please enter a valid email address.';
  }

  const phone = values.phone.trim();
  if (!phone) {
    errors.phone = 'Mobile number is required.';
  } else if (!/^\d+$/.test(phone)) {
    errors.phone = 'Mobile number must contain digits only.';
  } else if (phone.length < 6 || phone.length > 15) {
    errors.phone = 'Please enter a valid mobile number (6–15 digits).';
  }

  if (!values.message.trim()) {
    errors.message = 'Message is required.';
  }

  return errors;
}

export default function V2ContactPage() {
  const [ackVisible, setAckVisible] = useState(false);
  const [values, setValues] = useState(emptyValues);
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    const nextValue = field === 'phone' ? e.target.value.replace(/\D/g, '') : e.target.value;
    setValues((current) => ({ ...current, [field]: nextValue }));
    setErrors((current) => ({ ...current, [field]: undefined }));
    setAckVisible(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextErrors = validateContactForm(values);

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      setAckVisible(false);
      return;
    }

    setErrors({});
    setAckVisible(true);
    setValues(emptyValues);
  };

  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {contact.heroBadge}
          </span>
          <h1>
            {contact.heroTitle.map((p, i) =>
              typeof p === 'string' ? (
                <React.Fragment key={i}>{p}</React.Fragment>
              ) : (
                <span key={i} className="it">
                  {p.it}
                </span>
              )
            )}
          </h1>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="contact-grid">
            <div className="contact-card">
              <h2>Registered Office</h2>
              <p className="addr">
                <V2AddressText />
              </p>
              <p className="line">
                E: <a href={company.emailHref}>{company.emailDisplay}</a>
                <br />
                Tel: {company.phoneDisplay}
              </p>
              <div className="map">
                <iframe
                  title="Office location — Court Chambers, New Marine Lines, Mumbai"
                  src={company.mapEmbedUrl}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            <div className="contact-card contact-form-card">
              <h2>Send us a Message</h2>
              <form className="contact-form" noValidate onSubmit={handleSubmit}>
                <div className="form-field">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    autoComplete="name"
                    value={values.name}
                    onChange={handleChange('name')}
                    aria-invalid={errors.name ? 'true' : undefined}
                  />
                  {errors.name ? <p className="form-error">{errors.name}</p> : null}
                </div>
                <div className="form-field">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    autoComplete="email"
                    value={values.email}
                    onChange={handleChange('email')}
                    aria-invalid={errors.email ? 'true' : undefined}
                  />
                  {errors.email ? <p className="form-error">{errors.email}</p> : null}
                </div>
                <div className="form-field">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Mobile Number"
                    autoComplete="tel"
                    inputMode="numeric"
                    required
                    value={values.phone}
                    onChange={handleChange('phone')}
                    aria-invalid={errors.phone ? 'true' : undefined}
                  />
                  {errors.phone ? <p className="form-error">{errors.phone}</p> : null}
                </div>
                <div className="form-field">
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={values.message}
                    onChange={handleChange('message')}
                    aria-invalid={errors.message ? 'true' : undefined}
                  />
                  {errors.message ? <p className="form-error">{errors.message}</p> : null}
                </div>
                <div className="submit-row">
                  <button type="submit" className="btn btn-primary btn-lg">
                    Submit →
                  </button>
                </div>
                <p className={`form-success${ackVisible ? ' is-visible' : ''}`}>
                  Thank you. We’ll be in touch shortly.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
